"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickTime = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const TimeRanges_1 = __importDefault(require("@opsbase/lib-time/TimeRanges"));
const utils_1 = require("@opsbase/lib-time/utils");
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const StaticTimeRangePicker_1 = __importDefault(require("@opsbase/web-pickers/DatePicker/StaticTimeRangePicker"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
function PickTime(props) {
    const { queryField, onSelect, onCancel } = props;
    const [newFilter, setNewFilter] = (0, react_1.useState)({
        queryFieldKey: queryField.key,
        from: (0, moment_timezone_1.default)().tz('UTC').startOf('day'),
        to: (0, moment_timezone_1.default)().tz('UTC').startOf('day').add(6, 'hours'),
    });
    const handlePickTimeRange = (0, react_1.useCallback)(([from, to]) => {
        if (!from || !to)
            return;
        const mFrom = (0, moment_timezone_1.default)(from).tz('UTC');
        const mTo = (0, moment_timezone_1.default)(to).tz('UTC');
        const title = (0, utils_1.titleFromTimeRange)(mFrom, mTo);
        setNewFilter({ queryFieldKey: queryField.key, title, from: mFrom, to: mTo });
    }, [queryField.key]);
    const handlePickStaticTimeRange = (0, useCallforward_1.default)(dateRange => () => {
        const title = dateRange.title;
        const from = dateRange.from();
        const to = dateRange.to(from);
        const interval = dateRange.interval;
        setNewFilter({ queryFieldKey: queryField.key, title, from, to, interval });
    }, [queryField.key]);
    const handleClickOk = (0, react_1.useCallback)(() => {
        onSelect(newFilter);
    }, [onSelect, newFilter]);
    const handleClickCancel = (0, react_1.useCallback)(() => {
        onCancel();
    }, [onCancel]);
    return (react_1.default.createElement(Vertical_1.default, null,
        react_1.default.createElement(Horizontal_1.default, { gutter: true },
            react_1.default.createElement(Vertical_1.default, { padding: true, gutter: true }, Object.values(TimeRanges_1.default).map(timeRange => {
                const from = timeRange.from();
                const to = timeRange.to(from);
                const isSelected = newFilter.from.isSame(from) && newFilter.to.isSame(to);
                return (react_1.default.createElement(Button_1.default, { key: timeRange.title, background: !isSelected, color: lib_palette_1.default.secondary, onClick: handlePickStaticTimeRange(timeRange), label: timeRange.title }));
            })),
            react_1.default.createElement(StaticTimeRangePicker_1.default, { timezone: "UTC", value: [newFilter.from, newFilter.to], onChange: handlePickTimeRange })),
        react_1.default.createElement(Horizontal_1.default, { padding: true, gutter: true },
            react_1.default.createElement(Button_1.default, { label: lib_i18n_1.default.t('cancel'), color: lib_palette_1.default.LavendarGrey, onClick: handleClickCancel }),
            react_1.default.createElement(Button_1.default, { label: lib_i18n_1.default.t('ok'), color: lib_palette_1.default.positive, onClick: handleClickOk }))));
}
exports.PickTime = PickTime;
exports.default = PickTime;
